import airbrake from "utils/airbrake"
import "components/icon"

import ForecastTableData from "./data"
import ForecastTableScroll from "./scroll"
import ForecastTableContent from "./content"
import "./forecast-table.scss"
import "components/forecast-table/custom.scss"
import "./static/icon-chevron-circle-left.svg"
import "./static/icon-chevron-circle-right.svg"
import "./static/icon-snowflake.svg"

require.context("./static", false, /.{1,}/)

export default function init({ onDetailIncrease, onHindcastRequest } = {}) {
  const container = document.getElementById("forecast-table")
  if (!container) return

  const tables = Array.from(container.querySelectorAll("[data-content]"))
  if (!tables.length) return

  const { dataUrl: url, level, levels, model } = window.FCGON
  const data = new ForecastTableData(url, levels || [level], level, model)
  const content = new ForecastTableContent(tables, data, level, model, onDetailIncrease)
  new ForecastTableScroll(container, content, onHindcastRequest)

  window.setTimeout(() => container.classList.add("is-current-hour-hidden"), 5 * 60 * 1000)

  window.changeElevation = (elev) => content.changeLevel(elev)
  window.changeModel = (model) => content.changeModel(model)

  const expandAll = document.querySelectorAll("[data-table-expand-all]")
  Array.from(expandAll).forEach((button) => {
    let loading = false
    let expanded = false
    button.addEventListener("click", async (event) => {
      event.preventDefault()
      if (loading) return

      loading = true
      button.classList.add("is-loading")

      try {
        await (expanded ? content.collapseAll() : content.expandAll())
        expanded = !expanded
        // eslint-disable-next-line no-param-reassign
        button.textContent = button.dataset[expanded ? "collapse" : "expand"]
      } catch (e) {
        airbrake.notify(e)
      }

      button.classList.remove("is-loading")
      loading = false
    })
  })
}
